module.exports = __webpack_public_path__ + "media/images/mein-einkauf/mein-einkauf-ch-logo-rollover-df141debf885d66fcc5e77cd0af08726.png";